export default function install(Vue) {
  if (install.installed) return;
  install.installed = true;

  const isWeChat = navigator.userAgent.toLowerCase().match(/micromessenger/i);
  const isIOS = navigator.userAgent.toLowerCase().match(/iphone|ipad/i);
  const needOverride = l => isWeChat && isIOS && l.route.meta && (l.route.meta.canShare || l.route.meta.canPay);
  // const needOverride = () => true;
  const supportsHistory = history.pushState || false;

  Vue.mixin({
    beforeCreate: function beforeCreate() {
      if (this.$router && !install.override) {
        install.override = true;

        const push = this.$router.push.bind(this.$router);
        const replace = this.$router.replace.bind(this.$router);

        this.$router.push = (location) => {
          console.log('---------push location', location);
          const l = this.$router.resolve(location);
          if (needOverride(l)) {
            console.log('---------push', l);
            let path = l.route.fullPath;
            if (path.indexOf('is_platform=') == -1) {
              path = path + `&is_platform=${G.is_platform !== undefined ? G.is_platform : 0}`;
            }
            if (supportsHistory) {
              window.location.assign(path);
            } else {
              // window.location.assign(l.route.fullPath)
              window.location.assign('/?#' + path);
            }
          } else {
            push(location);
          }
        };
        this.$router.replace = (location) => {
          const l = this.$router.resolve(location);
          if (needOverride(l)) {
            console.log('---------replace', l, G.is_platform);
            let path = l.route.fullPath;
            if (path.indexOf('is_platform=') == -1) {
              path = path + `&is_platform=${G.is_platform !== undefined ? G.is_platform : 0}`;
            }
            console.log('---------replace', path);
            if (supportsHistory) {
              console.log('---------supportsHistory', path);
              window.location.replace(path);
            } else {
              // window.location.assign(l.route.fullPath)
              window.location.replace('/?#' + path);
            }
          } else {
            replace(location);
          }
        };
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/plugins/WXRouterPlugin.js